<template>
  <el-dialog
    :title="$t('member.tab.memberInfo.debindLineTitle')"
    :visible="show"
    width="400px"
    :close-on-click-modal="false"
    @close="$emit('update:show', false)"
  >
    <div v-loading="loading">
      <div>
        {{ $t('member.tab.memberInfo.debindLineContent') }}
      </div>
      <div class="btn-container">
        <BaseElButton
          style="width: 140px"
          plain
          @click="$emit('update:show', false)"
        >
          {{ $t('member.tab.memberInfo.cancel') }}
        </BaseElButton>
        <BaseElButton
          style="width: 140px"
          type="primary"
          @click="deleteMemberAuthLine"
        >
          {{ $t('member.tab.memberInfo.confirm') }}
        </BaseElButton>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { DeleteMemberAuthLine } from '@/api/member'
import { t } from '@/plugins/i18n/i18n'
export default {
  name: 'DeBindAuthLineDialog',
  props: ['show', 'member'],
  data: () => ({
    loading: false,
  }),
  computed: {
    shop () {
      return this.$store.getters.shop
    },
  },
  methods: {
    async deleteMemberAuthLine () {
      this.loading = true
      const [, err] = await DeleteMemberAuthLine({
        shopId: this.shop,
        id: this.member.id,
      })
      if (err) {
        this.loading = false
        this.$message.error(err)
        return
      }
      this.loading = false
      this.$message.success(t('member.tab.memberInfo.debindSuccess'))
      this.$emit('debind')
      // console.log(res)
    },
  },
}
</script>

<style lang="postcss" scoped>
.btn-container {
  @apply mt-[40px] flex justify-between;
}
</style>
